export default "__VITE_ASSET__be5e190b__"